import axios from "axios";

var baseURL = "https://loc.pickpoint.live";

if (
  window.location.hostname == "localhost" ||
  window.location.hostname == "loc.pickpoint.live"
) {
  baseURL = "https://loc.pickpoint.live";
}

if (window.location.hostname == "www.pickpoint.live") {
  baseURL = "https://www.pickpoint.live";
}

// Dev-Server (npm run serve): API relativ ansprechen, der Proxy in vue.config.js
// leitet an loc.pickpoint.live weiter (kein CORS, kein Ärger mit dem lokalen Zertifikat)
if (process.env.NODE_ENV === "development") {
  baseURL = "";
}

const http = axios.create({
  baseURL: baseURL,
  withCredentials: true,
  headers: {
    "Content-Type": "application/json",
  },
});

export default http;
